import React from 'react';

import { Value } from './Content.jsx';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import { default as _TypeConfig } from './TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function _CompanyContactInfo(props) { return <Value {...props} value={props.content} /> }
const CompanyContactInfo = Token.withContentTokenParsing(_CompanyContactInfo, {}, (props, keyword, options) => {
    const data = props.data || {};
    const gallery = data.Gallery || {};
    let replaceString = '';
    switch (keyword) {
        // case Token.Address.City:
        //     if (gallery.Address && !Utilities.isNullOrWhitespace(gallery.Address.City)) {
        //         replaceString = Token.getReplacementString(gallery.Address.City, options);
        //     }
        //     break;
        // case Token.Address.Country:
        //     if (gallery.Address && !Utilities.isNullOrWhitespace(gallery.Address.Country)) {
        //         replaceString = Token.getReplacementString(gallery.Address.Country, options);
        //     }
        //     break;
        case Token.Address.Line1:
            if (gallery.Address && !Utilities.isNullOrWhitespace(gallery.Address.LineOne)) {
                replaceString = Token.getReplacementString(gallery.Address.LineOne, options);
            }
            break;
        case Token.Address.Line2:
            if (gallery.Address && !Utilities.isNullOrWhitespace(gallery.Address.LineTwo)) {
                replaceString = Token.getReplacementString(gallery.Address.LineTwo, options);
            }
            break;
        case Token.Address.Location:
            if (gallery.Address && !Utilities.isNullOrWhitespace(gallery.Address.LocationWithZip)) {
                replaceString = Token.getReplacementString(gallery.Address.LocationWithZip, options);
            }
            break;
        // case Token.Address.State:
        //     if (gallery.Address && !Utilities.isNullOrWhitespace(gallery.Address.State)) {
        //         replaceString = Token.getReplacementString(gallery.Address.State, options);
        //     }
        //     break;
        // case Token.Address.Zip:
        //     if (gallery.Address && !Utilities.isNullOrWhitespace(gallery.Address.Zip)) {
        //         replaceString = Token.getReplacementString(gallery.Address.Zip, options);
        //     }
        //     break;
        case Token.CompanyName:
            if (!Utilities.isNullOrWhitespace(gallery.Company)) {
                replaceString = Token.getReplacementString(gallery.Company, options);
            }
            break;
        case Token.Phone.Default:
            if (!Utilities.isNullOrWhitespace(gallery.Phone)) {
                replaceString = Token.getReplacementString(gallery.Phone, options);
            }
            break;
        case Token.Website:
            if (!Utilities.isNullOrWhitespace(gallery.Website)) {
                replaceString = Token.getReplacementString(gallery.Website, options);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = () => [
    Token.getWrappedTokenConfig('Company Name', Token.CompanyName),
    Token.getWrappedTokenConfig('Address Line 1', Token.Address.Line1),
    Token.getWrappedTokenConfig('Address Line 2', Token.Address.Line2),
    Token.getWrappedTokenConfig('Location', Token.Address.Location),
    // Token.getWrappedTokenConfig('City', Token.Address.City),
    // Token.getWrappedTokenConfig('State', Token.Address.State),
    // Token.getWrappedTokenConfig('Zip', Token.Address.Zip),
    // Token.getWrappedTokenConfig('Country', Token.Address.Country),
    Token.getWrappedTokenConfig('Phone Number', Token.Phone.Default),
    Token.getWrappedTokenConfig('Website', Token.Website)
];
const TypeConfig = {
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    _TypeConfig.options.firstPageOnly(group),
                    {
                        display: 'Display Text',
                        fullWidth: true,
                        group,
                        name: 'design',
                        type: 'rich-text-collateral',
                        value: `${Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header1, text: `{${Token.CompanyName}("before":"","after":"")}`, token: Token.CompanyName })}${Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header4, text: `{${Token.Address.Line1}("before":"","after":"")}`, token: Token.Address.Line1 })}${Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header4, text: `{${Token.Address.Line2}("before":"","after":"")}`, token: Token.Address.Line2 })}${Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header4, text: `{${Token.Address.Location}("before":"","after":"")}`, token: Token.Address.Location })}${Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header4, text: `{${Token.Phone.Default}("before":"","after":"")}`, token: Token.Phone.Default })}${Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header4, text: `{${Token.Website}("before":"","after":"")}`, token: Token.Website })}`,
                    }
                ]
            };
        },
        style: () => _TypeConfig.panel.layoutStyle('style', 'Layout')
    }
};

export {
    CompanyContactInfo as Component,
    Tokens,
    TypeConfig
};